import Vue from 'vue'
import Vuex from 'vuex'
import { account } from '@/utils/request'
import interview from './interview'
import summary from './summary'
import { toLogin } from '@/utils'
import { getUA } from '@kmt/ua'

Vue.use(Vuex)
Vue.config.devtools = true // 调试代码

export default new Vuex.Store({
  state: {
    userInfo: {},
    ua: getUA(),
  },
  getters: {
    companyId (state) {
      return state.userInfo.companyid
    },
    isMobile (state) {
      return state.ua.isMobile
    }
  },
  mutations: {
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
    }
  },
  actions: {
    async getUserInfo ({ commit }) {
      try {
        const { data } = await account.get('/api/v3/islogin')
        commit('setUserInfo', data)
      } catch (error) {
        if (error.response?.status === 403) {
          toLogin()
        }
      }
    },
  },
  modules: {
    interview,
    summary
  }
})
